/*core module*/
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

import { APP_INITIALIZER } from '@angular/core';

import { FormsModule } from '@angular/forms'; 

/*project Component*/
import { AppComponent, HtmlreaderDirectiveHeader, HtmlreaderDirectiveFooter } from './app.component';
/*configuration file for the external json*/
import { ConfigService } from './config.service';
import { ConfigLoader } from './config-loader';
import { Step1CalcComponent } from './step1-calc/step1-calc.component';

import { DateValidator } from './step1-calc/date.validator';

/**********************************************/
/*related to this specific project*/
//import { TreeViewComponent, PageCategoryTitleComponent} from './treeView.component';
//import { ContentListComponent } from './content-list.component';

import {LoadingContainer, LoadingPage} from	'./loading-container';
import { ContentService } from './content.service';
import { Step2CalcComponent } from './step2-calc/step2-calc.component';

import { MyDatePickerModule } from 'mydatepicker';

import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { Ng2CompleterModule } from "ng2-completer";
import { AutoCompleterComponent } from './auto-completer/auto-completer.component';

import { ReCaptchaModule } from 'angular2-recaptcha';

/*plug in*/
/************** ** */

//import { RouterModule, Routes } from '@angular/router';

//const appRoutes: Routes = [
//	{ path: ':catId', redirectTo: '/index2.html', pathMatch: 'full' }
//];


@NgModule({
	declarations: [
		HtmlreaderDirectiveHeader, HtmlreaderDirectiveFooter, 
		AppComponent, Step1CalcComponent, DateValidator, Step2CalcComponent,
		//, TreeViewComponent, ContentListComponent, PageCategoryTitleComponent,
		LoadingContainer,
		AutoCompleterComponent
  ],
  imports: [
	//RouterModule.forRoot(appRoutes),
	FormsModule,
	BrowserModule,
	HttpModule
	  , MyDatePickerModule
	  , NguiAutoCompleteModule
	  , Ng2CompleterModule
	  , ReCaptchaModule
  ],
  providers: [
	  ContentService,
	  ConfigService,
	  {
		  provide: APP_INITIALIZER,
		  useFactory: ConfigLoader,
		  deps: [ConfigService],
		  multi: true
	  }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts